export default "__VITE_ASSET__e15058e4__"